import { Card, CardContent, Typography } from "@mui/material";

const StepCard = ({ step, title, description, icon }) => {
  return (
    <Card
      sx={{
        textAlign: "center",
        p: 1,
        boxShadow: 3,
        width: "260px", // 300px
        borderRadius: 3,
      }}
    >
      <CardContent>
        {icon}
        <Typography
          variant="subtitle2"
          color="text.secondary"
          mt={2}
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          STEP {step}
        </Typography>
        <Typography
          variant="h6"
          sx={{ fontFamily: '"Poppins", serif', fontSize: "1.1rem" }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontFamily: '"Poppins", serif' }}
        >
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default StepCard;
